import React, { useMemo } from 'react'
import { renderToString } from 'react-dom/server'
import { Icon } from '@manychat/manyui'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import {
  ContainerAppearance,
  ContentContainer,
} from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { NoButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartDynamicBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartDynamicBlock'

import { EmptyDynamic } from './EmptyDynamic'

const COLOR_EMPTY = '#8D9EB2'
const COLOR_DEFAULT = '#825DEE'

export const DynamicGenericBlock: BlockComponent<FlowChartDynamicBlock> = (props) => {
  const { url, fallback } = props.block.data

  const isEmpty = !url

  const IconString = useMemo(() => {
    return renderToString(
      <Icon.CloudUpload size={64} color={isEmpty ? COLOR_EMPTY : COLOR_DEFAULT} />,
    )
  }, [isEmpty])

  if (isEmpty) {
    return <EmptyDynamic icon={IconString} fallback={fallback} />
  }

  return (
    <NoButtonStatContextProvider>
      <InteractiveBlockContainer id={props.block.id}>
        <ContentContainer appearance={ContainerAppearance.EXTERNAL}>
          <TextWithIcon icon={IconString}>{url}</TextWithIcon>
          {fallback !== null && <Button button={fallback} />}
        </ContentContainer>
      </InteractiveBlockContainer>
    </NoButtonStatContextProvider>
  )
}
